import { AccessCodesDto, bmxCodes } from '../../api/Prospect';
import * as React from 'react';
import { ProspectInfoRow } from '../pages/admin/dashboardWidgets/prospectInfoRow';
import { Col, Row } from 'reactstrap';

interface Props {
    accessCodes: AccessCodesDto;
    prospectFacingText: boolean;
    bmxAccessCodes: bmxCodes[];
    externalStyle?: string;
    headingStyle?: string;
}

const TourAccessInformation = (props: Props) => {

    return (
        <div className={props.externalStyle!=null? "tour-accessCodes " + props.externalStyle : "tour-accessCodes"}>
            <h4 className={props.headingStyle!=null?props.headingStyle :"accessCodesHeader"}>Access Codes:</h4>
            <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    fontSize: '15px',
                    marginLeft: '8px'
                }}>
                {props.accessCodes.manualAccessCode && (
                    <div>
                        <div>
                            <ProspectInfoRow
                                label="Building Entrance Code:"
                                value={props.accessCodes.manualAccessCode}
                                singleColumn={props.prospectFacingText}
                            />
                        </div>{' '}
                        {props.prospectFacingText && (
                            <div>
                                <Row>
                                    <Col>
                                        <ul>
                                            <li>Enter code. Door will buzz.</li>
                                            <li>Grab door handle and enter.</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        )}{' '}
                    </div>
                )}
                {props.accessCodes.bmxDirectIntegrationQRCode && (
                    <div>
                        <div>
                            <ProspectInfoRow
                                label={'ButterflyMX'}
                                value={''}
                                singleColumn={props.prospectFacingText}
                            />
                        </div>
                        <div>
                            <div>
                                <span>Pin: {props.accessCodes.bmxDirectIntegrationPinCode} </span>
                            </div>
                            <img
                                src={props.accessCodes.bmxDirectIntegrationQRCode}
                                alt={'QR Code'}
                                width="75%"
                                height="75%"
                            />
                        </div>
                        {props.prospectFacingText && (
                            <div>
                                <Row>
                                    <Col>
                                        <ul>
                                            <li>TAP Virtual Key button on callbox.</li>
                                            <li>
                                                With your phone facing intercom, line up QR code.
                                            </li>
                                            <li>
                                                Callbox will chime upon acceptance. Door will
                                                unlock.
                                            </li>
                                            <li>
                                                Use the Pin above if QR code does not work.
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </div>
                )}
                {props.accessCodes.bmxCode && (
                    <div>
                        <div>
                            <ProspectInfoRow
                                label={'ButterflyMX'}
                                value={''}
                                singleColumn={props.prospectFacingText}
                            />
                        </div>
                        <div>
                            <img
                                src={props.accessCodes.bmxCode}
                                alt={'QR Code'}
                                width="75%"
                                height="75%"
                            />
                        </div>
                        {props.prospectFacingText && (
                            <div>
                                <Row>
                                    <Col>
                                        <ul>
                                            <li>TAP Virtual Key button on callbox.</li>
                                            <li>
                                                With your phone facing intercom, line up QR code.
                                            </li>
                                            <li>
                                                Callbox will chime upon acceptance. Door will
                                                unlock.
                                            </li>
                                            <li>
                                                Use the Pin above if QR code does not work.
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </div>
                )}
                {props.accessCodes.doorkingCode && (
                    <div>
                        <div>
                            <ProspectInfoRow
                                label={props.prospectFacingText ? 'Code' : 'DoorKing Code'}
                                value={props.accessCodes.doorkingCode}
                                singleColumn={props.prospectFacingText}
                            />
                        </div>
                        {props.prospectFacingText && (
                            <div>
                                <Row>
                                    <Col>
                                        <ul>
                                            <li>Press # if available on callbox. </li>
                                            <li>Enter four-digit code above. Door will buzz.</li>
                                            <li>
                                                Grab door handle and enter. <br />
                                                (If you need to start over, press #.)
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </div>
                )}
                {props.accessCodes.brivoPin && (
                    <div>
                        {' '}
                        <div>
                            <ProspectInfoRow
                                label={props.prospectFacingText ? 'PIN' : 'Brivo PIN'}
                                value={props.accessCodes.brivoPin}
                                singleColumn={props.prospectFacingText}
                            />
                        </div>{' '}
                        {props.prospectFacingText && (
                            <div>
                                <Row>
                                    <Col>
                                        <ul>
                                            <li>
                                                Use <i>Building Entrance Pin Code</i> above.
                                            </li>
                                            <li>Press #. Door will buzz.</li>
                                            <li>Grab door handle and enter.</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </div>
                        )}{' '}
                    </div>
                )}
                {props.accessCodes.igloohomeCodes &&
                    props.accessCodes.igloohomeCodes.map((code, index) => (
                        <ProspectInfoRow
                            key={index}
                            label={
                                props.prospectFacingText
                                    ? `${code.lockName} Keybox Code:`
                                    : `${code.lockName} Code (Igloohome)`
                            }
                            value={code.code}
                            singleColumn={props.prospectFacingText}
                        />
                    ))}
                { props.accessCodes.masterLockCodes && <div
                    className={
                        'font-weight-bold pl-0' +
                        (props.prospectFacingText ? ' col-sm-12' : ' col-sm-5')
                    }
                  >
                    {props.prospectFacingText
                                        ? `Master Lock Keybox Code:`
                                        : `Master Lock Code (Master Lock)`}
                </div>}
                {props.accessCodes.masterLockCodes &&
                    props.accessCodes.masterLockCodes.map((code, index) => {
                        return <div key={index} className={props.prospectFacingText ? 'col-sm-12' : 'col-sm-7'}>  {`${code.lockName || 'Unknown'} - ${code.code}`}
                </div>
                    })
                }
                {props.accessCodes.masterLockCodes && props.accessCodes.masterLockCodes.length > 0 && props.prospectFacingText && (
                    <Row>
                        <Col>
                            <b>TO OPEN KEYBOX:</b>
                            <ul>
                                <li>Enter the assigned code above.</li>
                                <li>Box will beep, and circle button will turn green.</li>
                                <li>Pull the tabs on the side of the Keybox to open it.</li>
                            </ul>
                            <b>TO CLOSE KEYBOX:</b>
                            <ul>
                                <li>
                                    Close Keybox tightly. Wait for beep to signal box is locked.
                                </li>
                            </ul>
                        </Col>
                    </Row>
                )}
                {props.accessCodes.latchLink && (
                    <ProspectInfoRow label="Latch Link" singleColumn={props.prospectFacingText}>
                        <a href={props.accessCodes.latchLink}>Latch Link</a>
                    </ProspectInfoRow>
                )}
                {props.accessCodes.remoteLockPin ||
                    (props.accessCodes.algorithmicRemoteLockPin && (
                        <ProspectInfoRow
                            label={props.prospectFacingText ? 'PIN' : 'RemoteLock PIN'}
                            value={
                                props.accessCodes.remoteLockPin ||
                                props.accessCodes.algorithmicRemoteLockPin
                            }
                            singleColumn={props.prospectFacingText}
                        />
                    ))}
                <Row>
                    <Col><b>UNIT CODES</b>
                        {props.accessCodes && props.accessCodes.smartRentAccessCodes && props.accessCodes.smartRentAccessCodes.map((unit: { name: string, accessCode: string }) => {
                            return (
                                <Col
                                    key={unit.accessCode}
                                    className="smart-rent-key-code"
                                >
                                    <div>
                                        {unit.name} : {unit.accessCode}
                                    </div>
                                </Col>
                            );
                        })
                        }
                        {props.accessCodes && props.accessCodes.geokeyAccessCodes && props.accessCodes.geokeyAccessCodes.map((unit: { name: string, accessCode: string }) => {
                            return (
                                <Col
                                    key={unit.accessCode}
                                    className="geo-key-code"
                                >
                                    <div>
                                        {unit.name} : {unit.accessCode}
                                    </div>
                                </Col>
                            );
                        })
                        }
                    </Col>


                </Row>
                {props.accessCodes.masterLockCodes && props.accessCodes.masterLockCodes.length > 0 && props.prospectFacingText && (
                    <Row>
                        <Col>
                            <b>AT THE END OF TOUR:</b>
                            <br />
                            Return the fob/key to the Keybox.
                            <br />
                            <br />
                            <b>
                                Failure to return the fob/key will result in a $150 fee charged
                                directly to your credit card.
                            </b>
                        </Col>
                    </Row>
                )}
            </div>
        </div>
    );
};

export default TourAccessInformation;



// WEBPACK FOOTER //
// ./src/components/common/TourAccessInformation.tsx